import { RadioGroup } from 'entities/RadioGroup'
import { getAppName } from 'shared/helpers/getAppName'
import { useConfigStore } from 'shared/store/configSlice'
import { useGlobalStore } from 'shared/store/globalSlice'

export const BookingVariantSelector = () => {
  const config = useConfigStore().config?.menuConfig
  const isCC = useGlobalStore().isCCSelected
  const updateMenuConfig = useConfigStore().updateMenuConfig

  const handleBookingVariant = (value: string) => {
    updateMenuConfig({ bookingVariant: Number(value) as 1 | 2 | 3 })
  }

  return (
    <RadioGroup
      isRow
      value={config?.[getAppName(isCC)]?.bookingVariant || 0}
      handleChange={handleBookingVariant}
      options={BookingVariantOptions}
      title='Booking variant'
    />
  )
}

const BookingVariantOptions = [
  {
    value: 1,
    label: 'Only view'
  },
  {
    value: 2,
    label: 'View and order'
  },
  {
    value: 3,
    label: 'Pay only'
  }
]
